module.exports = __webpack_public_path__ + "static/media/coin-music-price@2x.7ec361e0.png";